/*
  AironiMenager — en-tête « réapparaît quand on remonte » sans bug de menu.

  Dawn masque l'en-tête dès qu'on descend, même d'un pixel, et ne referme
  que le menu ordinateur. Sur téléphone, ouvrir le menu (ou la recherche)
  depuis l'en-tête réapparu au milieu de la page, puis bouger très
  légèrement (repli de la barre d'adresse, doigt qui glisse), masquait
  l'en-tête… avec le menu ouvert dedans : il « disparaissait », et on ne le
  retrouvait qu'en remontant tout en haut de la page.

  Correctifs, sans toucher au fichier de Dawn :
  - l'en-tête ne se masque pas tant qu'un menu, un sous-menu ou la
    recherche est ouvert ;
  - les petits mouvements (moins de 12 px) ne masquent plus l'en-tête.
*/
(function () {
  if (!window.customElements) return;

  customElements.whenDefined('sticky-header').then(function () {
    var Classe = customElements.get('sticky-header');
    if (!Classe || Classe.prototype.amCorrige) return;
    Classe.prototype.amCorrige = true;

    var hideOriginal = Classe.prototype.hide;
    Classe.prototype.hide = function () {
      var entete = this.header;
      if (entete) {
        var menuOuvert =
          entete.classList.contains('menu-open') ||
          entete.querySelector('details[open]') ||
          document.body.classList.contains('overflow-hidden-tablet') ||
          document.body.classList.contains('overflow-hidden-mobile');
        if (menuOuvert) return;
      }

      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (typeof this.amDernierY === 'number' && Math.abs(y - this.amDernierY) < 12) return;
      this.amDernierY = y;

      return hideOriginal.apply(this, arguments);
    };

    var revealOriginal = Classe.prototype.reveal;
    Classe.prototype.reveal = function () {
      this.amDernierY = window.pageYOffset || document.documentElement.scrollTop;
      return revealOriginal.apply(this, arguments);
    };
  });
})();
